module.exports = __webpack_public_path__ + "img/op-vs-rep.682a1f0b.png";